module.exports = __webpack_public_path__ + "media/images/site/CINFANTIL_NOSSA_DIDATICA-a91555b9d07da7d8a54954ed1702c70f.jpg";